import { TALENT_POOL_NAMES } from '~/enum/positions'
import { sortPositions } from '~/utils/positions'

export default {
  props: {
    positions: {
      type: Array,
      required: true,
      default: [],
    },
    twoColumns: {
      type: Boolean,
    },
    emptyPositionsText: {
      type: String,
    },
    title: {
      type: String,
    },
    gtm: {
      type: Object,
    },
    scroll: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      talentPool: this.getTalentPool(),
      orderPositions: this.sortPositions(),
    }
  },
  computed: {
    hasEmptyPositionsText() {
      const hasEmptyPositionsText = this.emptyPositionsText
      if (hasEmptyPositionsText) return true
    },
    hasPositions() {
      return this.positions.length > 0
    },
  },
  methods: {
    getTalentPool() {
      return this.positions.find((position) =>
        this.getTalentName().includes(position.title.toLowerCase().trim())
      )
    },
    sortPositions() {
      const talentPoolName = TALENT_POOL_NAMES[this.$i18n.locale]

      return sortPositions(talentPoolName, this.positions)
    },
    getTalentName() {
      return TALENT_POOL_NAMES[this.$i18n.locale]
    },
  },
}
